import { TemplateElement, html, defineElement } from '@webtides/element-js';

/**
 * @property {string} title
 * @property {string} abstract
 * @property {array} socialList
 */
export default class SocialMediaSharing extends TemplateElement {
    properties() {
        return {
            title: '',
            abstract: '',
            socialList: [
                {
                    type: 'Facebook',
                    iconName: 'social--facebook',
                },
                {
                    type: 'Linked In',
                    iconName: 'social--linkedin',
                },
                {
                    type: 'Twitter',
                    iconName: 'social--twitter',
                },
                {
                    type: 'WhatsApp',
                    iconName: 'social--whatsapp',
                },
                {
                    type: 'E-Mail',
                    iconName: 'app--send',
                },
            ],
        };
    }

    template() {
        return html`
            <div class="flex flex-row gap-24">
                ${this.socialList.map(
                    (social) =>
                        html` <a
                            href="${this.createQueryString(social.type, this.title, this.abstract, window.location)}"
                            title="Auf ${social.type} teilen"
                            rel="nofollow noopener noreferrer"
                            target="_blank"
                        >
                            <mb-icon name="${social.iconName}" class="text-gray-40 hover:text-green-medium"></mb-icon>
                        </a>`,
                )}
            </div>
        `;
    }

    createQueryString(type, title, abstract, url) {
        switch (type) {
            case 'Facebook':
                const facebookParams = new URLSearchParams({
                    u: url,
                });
                return `https://www.facebook.com/sharer/sharer.php?${facebookParams.toString()}`;
            case 'Linked In':
                const linkedInParams = new URLSearchParams({
                    url: url,
                });
                return `https://www.linkedin.com/sharing/share-offsite/?${linkedInParams.toString()}`;
            case 'Twitter':
                const twitterParams = new URLSearchParams({
                    text: `${title}: ${url} via @migrosbank`,
                });
                return `https://twitter.com/intent/tweet?${twitterParams.toString()}`;
            case 'WhatsApp':
                const whatsAppParams = new URLSearchParams({
                    text: `${title}: ${url}`,
                });
                return `https://wa.me/?${whatsAppParams.toString()}`;
            case 'E-Mail':
                const encodedTitle = encodeURIComponent(title);
                const encodedBody = encodeURIComponent(`${abstract}\r\n\r\n${url}`);

                const eMailParams = `subject=${encodedTitle}&body=${encodedBody}`;

                return `mailto:?${eMailParams}`;
            default:
                throw new Error(
                    'Unbekannter Social Media Typ. Unterstützte Typen sind: "Facebook", "Linked In", "Twitter", "WhatsApp" und "E-Mail".',
                );
        }
    }
}

defineElement('mb-social-media-sharing', SocialMediaSharing);
